import { render } from "./app.vue?vue&type=template&id=c0b7a68e&scoped=true&ts=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=c0b7a68e&lang=scss"
import "./app.vue?vue&type=style&index=1&id=c0b7a68e&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b7a68e"]])

export default __exports__